module.exports = __webpack_public_path__ + "img/img-e33929.png";